import { render, staticRenderFns } from "./Advisories.vue?vue&type=template&id=cbb2d782&"
import script from "./Advisories.vue?vue&type=script&lang=js&"
export * from "./Advisories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports